import React, { Component } from "react"
import { Input, Row, message } from "antd"
import "./Index.scss"
import closeIcon from "app/styles/images/sp/close.svg"
import dataFileIcon from "app/styles/images/sp/data-file.svg"
import dataSearchIcon from "app/styles/images/sp/search.svg"
import MaterialModal from "app/components/normal/MaterialModal"
import { observer } from "mobx-react"
import MaterialFormItem from "app/components/normal/MaterialFormItem/MaterialFormItem"
import { Transfer } from "antd"
import cx from "classnames"
import { disposeFilename } from "app/vendor/util"

@observer
export default class TransferModal extends Component {
  state = {
    newGroupData: {
      appId: null,
      reports: {},
      groupName: ""
    },
    transferData: [],
    transferDataForShow: [],
    transferSelectedKeys: {
      all: [],
      sourceCount: 0,
      targetCount: 0,
    },
    transferTargetKeys: [],
    app: "0",              //头部筛选选中的状态 计算
  }

  renderNotFoundContent = () => {
    const { newGroupData, transferTargetKeys, transferData } = this.state
    if (!newGroupData.appId) {
      return  (
        <div className="not-found-content">
          <img alt="" src={dataFileIcon} />
          <div>请先选择应用后方可选择数据</div>
        </div>
      )
    } else if (transferTargetKeys.length === 0 && transferData.length > 0) {
      return "请在左侧选择数据后添加至此处"
    } else {
       return  (
         <div className="not-found-content">
           <img alt="" src={dataSearchIcon} />
           <div>暂无可选数据</div>
         </div>
       )
    }
  }

  handleSearch = (direction, event) => {
    if (direction === "left") {
      this.searchFromBackend(event)
    }
  }

  searchFromBackend = (event) => {
    if (!this.state.newGroupData.appId) {
      return
    }

    if (this.timer) {
      clearTimeout(this.timer)
    }
    const target = event.target

    this.timer = setTimeout(() => {
      this.loadSearchResult(target.value)
      clearTimeout(this.timer)
    }, 300)
  }

  loadSearchResult = (keyword) => { // search from backend
    const { getSearchData } = this.props.store
    const { newGroupData, transferData, transferTargetKeys } = this.state

    getSearchData(newGroupData.appId, keyword)
    .then(res => {
        let data = res.map(item => ({ ...item, key: item.dataId }))
        const targetData = transferData.filter(data => transferTargetKeys.includes(data.dataId))

        this.setState({
          transferData: [...data, ...targetData],
          transferDataForShow: [...data, ...targetData]
        })
      },
      err => {
        message.error(err.message)
      }
    )
  }

  crossSearch = () => {
    if (!this.state.newGroupData.appId) {
      return
    }

    this.loadSearchResult("")
  }

  createNewGroupOk = () => {
    //调用接口
    const { newGroupData } = this.state
    const { store: { createNewGroup, list: { getTableData, updateTableData } }, onClose } = this.props

    const uniqData = []
    // console.log('newGroupData', newGroupData)

    newGroupData.reports.forEach((oldItem) => {
      if (uniqData.length === 0) {
        uniqData.push(oldItem)
      }

      let shoudPush = true

      uniqData.forEach((newItem) => {
        if (
          newItem.dataId === oldItem.dataId
          && newItem.reportId === oldItem.reportId
          && newItem.taskId === oldItem.taskId
        ) {
          shoudPush = false
        }

      })
      shoudPush && uniqData.push(oldItem)
    })

    newGroupData.reports = uniqData

    createNewGroup(newGroupData)
    .then(
      res => {
        this.clearCreateNewGroupModalState()
        getTableData()
        .then(
          res => {
            updateTableData(res)
          }
        )
        message.success("新建报告组成功")
        onClose()
      },
      err => {
        message.error(err.message)
      }
    )
  }

  clearCreateNewGroupModalState = () => {
    this.setState({
      transferSelectedKeys: {
        all: [],
        sourceCount: 0,
        targetCount: 0,
      },
      transferData: [],
      transferDataForShow: [],
      transferTargetKeys: [],
      newGroupData: {
        appId: null,
        reports: {}
      },
    })
  }

  changeNewGroupData = (e, field) => {
    this.setState({
      newGroupData: {
        ...this.state.newGroupData,
        [field]: e.target.value
      }
    })
  }

  // 处理点击中间的穿梭按钮这个动作
  handleTransfer = (nextTargetKeys, direction, moveKeys) => {
    const { transferData } = this.state
    // console.log('nextTargetKeys', nextTargetKeys)
    // console.log('in transferData', transferData)
    this.setState({
      transferTargetKeys: nextTargetKeys,
      newGroupData: {
        ...this.state.newGroupData,
        reports: transferData.filter(report =>
          nextTargetKeys.includes(report.dataId)
        ).map(report =>
          ({ reportId: report.reportId, taskId: report.taskId, dataId: report.dataId })
        )
      }
    })
  }

  changeApp = (appId) => {
    this.setState({
      newGroupData: {
        ...this.state.newGroupData,
        "appId": appId,
      },
      transferSelectedKeys: {
        all: [],
        sourceCount: 0,
        targetCount: 0,
      },
      transferTargetKeys: [],
    })

    if (this.timer) { // 清除旧的 timer
      clearTimeout(this.timer)
    }

    this.timer = setTimeout(() => {
      this.loadReports(appId)
      clearTimeout(this.timer)
    }, 300)
  }

  loadReports = (appId) => {
    //调接口
    const { getReportByAppId } = this.props.store
    getReportByAppId(appId)
    .then(
      res => {
        let data = res.map(item => ({ ...item, key: item.dataId }))
        this.setState({
          transferData: data,
          transferDataForShow: data,
        })
      },
      err => {
        message.error(err.message)
      }
    )
  }

  // 处理选中项目这个动作
  handleSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
    this.setState({
      transferSelectedKeys: {
        all: [...sourceSelectedKeys, ...targetSelectedKeys],
        sourceCount: sourceSelectedKeys.length,
        targetCount: targetSelectedKeys.length,
      },
    })
  }

  renderTransferList = ({ filename, sampleName }) => {
    if (sampleName) {
      return `${sampleName}-${disposeFilename(filename).filename}`
    } else {
      return disposeFilename(filename).filename
    }
  }

  componentWillUnmount() {
    const crossAction = document.getElementsByClassName("anticon-cross-circle")[0]
    crossAction && crossAction.removeEventListener("click", this.crossSearch)
  }

  filterOption = (inputValue, option) => {
    return (option.filename + option.sampleName).search(new RegExp(inputValue, "i")) > -1
  }

  render () {
    const {
      newGroupData,
      transferDataForShow,
      transferTargetKeys,
      transferSelectedKeys,
    } = this.state

    const { store: { list: { apps } }, onClose } = this.props
    const isCreateable = newGroupData.groupName && transferTargetKeys.length !== 0
    const createNewGroupBtnClass = cx({
      "primary-btn": true,
      "disabled": !isCreateable
    })

    const crossAction = document.getElementsByClassName("anticon-cross-circle")[0]
    crossAction && crossAction.removeEventListener("click", this.crossSearch)
    crossAction && crossAction.addEventListener("click", this.crossSearch)

    return (
      <MaterialModal
        className="pgs-create-group-modal"
        title="新建报告组"
        width="calc(100vh * 2 - 323px * 2 + 38px + 48px)"
        visible
        footer={(
          <Row type="flex" justify="center" align="middle">
            <button
              disabled={
                isCreateable
                  ? ""
                  : "disabled"
              }
              className={createNewGroupBtnClass}
              onClick={() => this.createNewGroupOk()}
            >
              确定
            </button>
          </Row>
        )}
      >
        <img
          className="pgx-modal-close"
          src={closeIcon}
          alt="关闭对话框"
          onClick={onClose}
        />
        <Row type='flex' justify='start' align='middle' className='subtitle'>
          <i></i>
          <MaterialFormItem
            labelWidth={47}
            labelText="家系名称"
            className="group-name"
          >
            <Row type="flex" justify="start" align='middle'>
              <Input name="groupName" type="text"
                className="name-input"
                value={newGroupData.groupName}
                onChange={(e) => this.changeNewGroupData(e, "groupName")}
                placeholder="请输入新建家系名称"
              />
            </Row>
          </MaterialFormItem>
        </Row>
        <Row className="apps" type="flex" align="middle" justify="start">
          {
            apps.map(app => {
              let appClass = cx({
                "app cursor-p": true,
                "active": newGroupData.appId === app.id
              })
              return (
                <div
                  key={app.id + "createGroup"}
                  className={appClass}
                  onClick={() => this.changeApp(app.id)}
                >
                  {app.name}
                </div>
              )
            })
          }
        </Row>
        <Transfer
          key={newGroupData.appId}
          className="pgx-transfer create-new-group-transfer"
          dataSource={transferDataForShow}
          titles={[
            "待选报告    共"
            +(transferDataForShow.length - transferTargetKeys.length)
            + "条，已选"
            + transferSelectedKeys.sourceCount
            + "条",
            "已选报告    共" + transferTargetKeys.length + "条，已选" + (transferSelectedKeys.targetCount || 0) + "条"]}
          targetKeys={transferTargetKeys}
          searchPlaceholder={"输入文件名/样本名搜索"}
          showSearch={true}
          selectedKeys={transferSelectedKeys.all}
          onChange={this.handleTransfer}
          onSearchChange={this.handleSearch}
          filterOption={this.filterOption}
          onSelectChange={this.handleSelectChange}
          lazy={{height: 32, offset: 32}}
          render={this.renderTransferList}
          notFoundContent={
            this.renderNotFoundContent()
          }
        />
      </MaterialModal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/pgs/report/TransferModal.js